<template>
  <div>
    <section>
      <el-row>
        <el-col :span="2"> 
             <img class="avatar" :src="avatar?avatar:require('../../assets/avatar.png')"  min-width="100" height="100" />
        </el-col>
        <el-col :span="4">
            <el-col :span="24" style="margin-top: 10px;">
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                    <span style="font-size: 25px;">{{ userName }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 16px;color: #848181;">用户ID:</span>
                    <span style="font-size: 16px;color: #848181;">{{ userId }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
        <el-col :span="16" style="height:1px">
        </el-col>
        <el-col :span="2">
            <el-col :span="24" style="margin-top: 10px;">
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                     <span style="font-size: 16px;color: #848181;">领取卡券数</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 28px;">{{ couponNum }}张</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
      </el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
        <el-form :inline="true">
          <el-form-item class="form-class">
            <el-input v-model="couponName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="form-class">
            <el-button type="primary" v-on:click="getFilterList">查询</el-button>
          </el-form-item >
          <el-form-item class="form-class">
            <el-button type="default" >重置</el-button>
          </el-form-item >
        </el-form>
      </el-col>
      <el-table stripe align="left" :data="tableData" highlight-current-row v-loading="listLoading"
                style="width: 100%;">
        <el-table-column align="center" label="领取时间" :formatter="formatTime" min-width="40%">
          <template slot-scope="scope">
            <span>{{$comUtils.dateformat.format(scope.row.getTime,'yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="couponName" label="卡券名称" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="shopName" label="发券商户" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="couponType" label="卡券类型" :formatter="formatCouponType" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="couponStatus" label="状态" :formatter="formatCouponStatus" min-width="20%"></el-table-column>
        <el-table-column align="center"  label="核销时间" :formatter="formatTime" min-width="40%">
          <template slot-scope="scope">
            <span>{{$comUtils.dateformat.format(scope.row.useTime,'yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" class="button-bar" fixed='right'>
          <template slot-scope="scope">
            <el-button type="text"  size="small" @click="handleCouponDetail(scope.$index, scope.row)">卡券详情</el-button>
          </template>
			</el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page=currentPage
        :page-sizes="[10, 20, 30, 40]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=totalNumber>
      </el-pagination>
      <Dialog v-if="isShow" :propsData="propsData" @child-ok="childok" @child-cancel="childcancel"></Dialog>
    </section>
  </div>
</template>

<script>
  import {CouponOptions} from '../../views/details/detail-data.js'
  import Dialog  from '../../views/coupon/couponDetail.vue'
  export default {
    name: "coupon",
    components: {
      Dialog
    },
    data() {
      return {
        isShow:false,
        values: [],
        options: CouponOptions.data,
        tableDate: null,
        listLoading: false,
        totalAmount: 0,
        userId: null,
        userName: '',
        avatar:null,
        currentPage: 0,
        pageSize: 10,
        totalNumber: 0,
        timeInterval: '',
        CouponTypes:[{ label: '代金券', value: '1' }, { label: '免单卡', value: '2' },],
        CouponStatuss:[{ label: '未使用', value: '1' }, { label: '已使用', value: '2' },{ label: '已过期', value: '3' },],
        propsData:{},
        couponNum:0,
        couponName:'',
        tableData:[]
      }
    },

    methods: {
      formatTime(row, column) {
        if (!row.createTime) {
          return '';
        }
        return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
      },
      formatCouponType(row, column){
        let temp = this.CouponTypes.filter((item) => {
					return item.value == row.couponType;
				})
				return temp[0].label;
      },
      formatCouponStatus(row, column){
        let temp = this.CouponStatuss.filter((item) => {
					return item.value == row.couponStatus;
				})
				return temp[0].label;
      },
      getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage);
			},
      handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage);
      },
      handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage);
      },
      async getList(index) {
				let condition = {}
				condition.couponName = this.couponName;
        condition.userId =this.userId;
        condition.currentPage = index;
        condition.pageSize =this.pageSize;
				try{
					this.listLoading = true;
					let result = await this.$http.post(this,'/user/getHQCouponListByUser', {},condition);
					if (result && result.code == 200) {
						this.tableData = result.data.rows;
						this.totalNumber = result.data.total;
						this.listLoading = false;
					}
				} catch(e){
					this.listLoading = false;
				}
			},
      handleCouponDetail(index,row){
        this.propsData ={};
        this.propsData.userId =  this.userId;
        this.propsData.couponId = row.id;
        //this.$router.push({ path: '/operateManage/details', query: { userId: row.id,userName: row.nickName } });
      }
    },
    created() {
      this.userId = this.$route.query.userId;
      this.userName = this.$route.query.userName;
      this.avatar = this.$route.query.avatar;
      this.couponNum = this.$route.query.couponNum;
      this.listLoading = true
      this.getList(0);
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;

  .el-form-item {
    margin-bottom: 10px;
    width: 20%;
  }

  }

  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
</style>
